<template>
    <div class="news_index">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>
        <div class="mbx width_center_1200">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/article/" style="cursor: pointer;">文章</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

 
    <div class="article-content">
        <div class="article-search-hd mb20">
            <div class="w w1200">
                <div class="hd-tit">文档帮助中心</div>
            </div>
        </div>

    <div class="w w1200 clearfix">
        <div class="article-side">
            <dl class="article-menu">
                <dt class="am-t"><a href="javascript:void(0);">分类列表</a></dt>
    <el-menu class="el-menu-vertical-demo" default-active="0">
        <el-submenu v-for="v in column_list" :key="v.id" :index="v.code">
        <template slot="title">
          <span>{{ v.name }}</span>
        </template>
        <el-menu-item-group v-if="v.content">
          <el-menu-item v-for="secMenu in v.content" :key="secMenu.id" :index="secMenu.id"> <a :href="'/article/info/'+secMenu.id" target="_blank">{{ secMenu.newsTitle }}</a></el-menu-item>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>
            </dl>
        </div>
    <div class="article-main">
                <div class="am-hd">
                    <h2>{{ info.newsTitle }}</h2>
        <!-- <div class="extra"><time>发布时间：2020-07-30 11:18</time></div> -->
                </div>
                <div class="am-bd">
                   
                    <div class="article-words" >
                        <div v-html="info.newText"></div>
                    </div>

                </div>
    </div>
    </div>



</div>






        <ShopMbar></ShopMbar>
        <shop-foot></shop-foot>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
export default {
    metaInfo(){
      return {
        title: this.pageName
      }
    },
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
    },
    data() {
      return {
          info:[],
          querynews:[],
          column_list:[],
          pageName: 'loading',
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 栏目列表
        get_column_list:function(){
             this.$get(this.$api.getHelpCenter).then(res=>{
                this.column_list = res.data;
            });
        },
        // 新闻详情
        get_news_info:function(){
            this.$get(this.$api.getItem+this.id).then(res=>{
                this.info = res.data;
                this.querynews = res.data;
                this.info.newsTitle =res.data.newsTitle;

            });
        },
    },
    created() {
        this.id = this.$route.params.info;
        this.get_column_list();
        this.get_news_info();
    },
    mounted() {
      setTimeout(() => {
        this.pageName = this.info.newsTitle;
      }, 2000);
    }
};
</script>
<style lang="scss" scoped>
.el-submenu [class^=el-icon-] {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 12px;
}
.el-menu-item-group__title{
    padding: 0;
}
// .el-submenu.is-active .el-submenu__title{
//   border-bottom: none;
// }
.extra time {
    font-size: 12px;
    color: #b4b4b4;
}
</style>